export default function StepProgress({ step }) {
    const items = ["Business Details", "Theme Selection", "Review & Actions"];

    return (
        <div className="wg-step-progress">
            {items.map((item, index) => {
                const current = index + 1;
                return (
                    <div
                        key={item}
                        className={`wg-step-item ${step === current ? "active" : ""}`}
                    >
                        <div className="wg-step-top">
                            <div className="wg-step-number">{current}</div>
                            <div className="wg-step-title">{item}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}